import PageLoader from "../../feedback/page-loader";

export default PageLoader;
